import { useState } from "react";
import { Formik, Form, Field } from "formik";
// import { useAuth } from "../context/AuthContext";
import Toaster, { ToastContainerComponent } from "../components/Toaster";
import FullScreenLoader from "../components/FullScreenLoader";
import { useNavigate, Link } from "react-router-dom";
import { forgotPasswordApi } from "../utils/api";
const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [isSubmitting,setIsSubmitting] = useState(false)
    const navigate = useNavigate();

    const handleForgotPassword = async (values) => {
      if (!values.email) {
        Toaster.error("Please provide email.");
        return;
      }
      setLoading(true); // Show loader
      try {
        setIsSubmitting(true)
        await forgotPasswordApi(values.email);
        sessionStorage.setItem("getEmail", values.email);
        sessionStorage.setItem("getAction", "resetPassword");
        navigate("/reset-password");
      } catch (error) {
        setIsSubmitting(false)
        Toaster.error("Failed to send otp. Please check your Email.");
      } finally {
        setIsSubmitting(false)
        setLoading(false); // Hide loader after request
      }
    };
    return (
        <>
          <FullScreenLoader loading={loading} />
          <div className="login_page">
            <ToastContainerComponent />
            <div className="login">
              <div className="login_left">
                <div className="login_box">
                  <h2>Forgot Password</h2>
                  <Formik
                     initialValues={{ username: "" }}
                     onSubmit={(values) => {
                       handleForgotPassword(values);
                     }}  >
                    {/* {({ isSubmitting }) => ( */}
                      <Form className="login_form">
                        <div className="input_field">
                       
                          <Field
                            className="form_control"
                            type="text"
                            name="email"
                            placeholder="Email"
                          />
                          <span className="icon">
                            <i className="fa-solid fa-user"></i>
                          </span>
                        </div>
                        <button
                          type="submit"
                          className="login_btn"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Sending OTP..." : "Send OTP"}
                        </button>
                      </Form>
                    {/* )} */}
                  </Formik>
                </div>
              </div>
              <div className="login_right">
                <div className="logo">
                  <img src="./images/logo.png" alt="Logo" />
                </div>
                <h2>
                  Welcome! <br /> Smart Choice Formation
                </h2>
              </div>
            </div>
            
          </div>
    
        </>
      );
};

export default ForgotPassword;
